module.exports = __webpack_public_path__ + "img/3.6d28c6cf.png";